<template>
    <div>
        <b-row>
            <b-col cols="12" lg="12">
                <app-form-textarea-input
                    label="Notas"
                    id="notes"
                    v-model="theCheckpoint.notes"
                    :required="true"
                    :hasError="$v.theCheckpoint.notes.$error"
                    errorMessage="Debe escribir las notas"
                    @input="$v.theCheckpoint.notes.$touch()"
                />
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    :disabled="true"
                    label="Latitud"
                    id="latitude"
                    v-model="theCheckpoint.latitude"
                    :required="true"
                    :hasError="$v.theCheckpoint.latitude.$error"
                    errorMessage="Debe especificar la latitud"
                    @input="$v.theCheckpoint.latitude.$touch()"
                />
            </b-col>
            <b-col cols="12" md="6" lg="6">
                <app-form-text-input
                    :disabled="true"
                    label="longitud"
                    id="longitude"
                    v-model="theCheckpoint.longitude"
                    :required="true"
                    :hasError="$v.theCheckpoint.longitude.$error"
                    errorMessage="Debe especificar la longitud"
                    @input="$v.theCheckpoint.longitude.$touch()"
                />
            </b-col>
            <b-col cols="12" md="12" lg="12">
                <b-btn class="btn-block" variant="primary" @click="getLocation">
                    <i class="fa fa-map-marker" aria-hidden="true"></i> Obtener
                    ubicación actual
                </b-btn>
            </b-col>
            <b-col>
                <b-card tag="article" style="max-width: 100%;" class="mb-2">
                    <div class="card-text">
                        <h4>Foto del punto de control</h4>
                        <app-webcam-lite
                            :max-width="768"
                            v-model="theCheckpoint.file"
                            ref="fileinput"
                        />
                        <!-- <b-form-file
                            required
                            v-model="theCheckpoint.file"
                            :state="Boolean(theCheckpoint.file)"
                            placeholder="Tome la foto"
                            accept="image/*"
                            :capture="true"
                            ref="fileinput"></b-form-file>
                        <div v-if="theCheckpoint.file" class="mt-3">Archivo seleccionado: {{theCheckpoint.file && theCheckpoint.file.name}}</div>-->
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-checkbox
                    v-model="theCheckpoint.notify"
                    :unchecked-value="0"
                    :value="1"
                >Notificar al cliente</b-checkbox>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import bodyguardRepository from '../../../../../repositories/bodyguard.repository'
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '../../../../../store/commitTypes'
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        serviceId: {
            required: true,
        },
        onSave: {
            type: Function,
        },
    },
    data() {
        return {
            theCheckpoint: {
                latitude: '',
                longitude: '',
                file: '',
                notes: '',
                notify: 0,
            },
        }
    },
    validations: {
        theCheckpoint: {
            latitude: { required },
            longitude: { required },
            notes: { required },
        },
    },
    methods: {
        getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.theCheckpoint.latitude = position.coords.latitude + ''
                    this.theCheckpoint.longitude =
                        position.coords.longitude + ''
                })
            }
        },
        saveCheckpoint() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const formData = new FormData()

            formData.append('serviceId', this.serviceId)
            formData.append('longitude', this.theCheckpoint.longitude)
            formData.append('latitude', this.theCheckpoint.latitude)
            formData.append('notes', this.theCheckpoint.notes)
            formData.append('notify', this.theCheckpoint.notify)

            if (this.theCheckpoint.file) {
                formData.append('file', this.theCheckpoint.file)
            }

            const br = { ...bodyguardRepository }

            br.saveCheckpoint(formData)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.cleanFields()
                        typeof this.onSave === 'function' &&
                            this.onSave(data.checkpoint)
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    this.handleErrors(error)
                    // toastr.error('Error al guardar el punto de control');
                })
        },
        cleanFields() {
            this.$refs.fileinput.reset()
            Object.keys(this.theCheckpoint).map(
                key => (this.theCheckpoint[key] = '')
            )
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },
    created() {
        this.$bus.$on('service-checkpoint-form.save', this.saveCheckpoint)
        this.$bus.$on('service-checkpoint-form.clean', this.cleanFields)
        this.$bus.$on('current-location.get', this.getLocation)
    },
    beforeDestroy() {
        this.$bus.$off('service-checkpoint-form.save')
    },
    mounted() {},
}
</script>
